<template>
  <v-dialog v-model="showDialog" persistent max-width="600">
    <v-card>
      <v-toolbar density="compact" :class="`px-6 py-1 bg-${getColor}`">
        <v-icon v-if="configs.type === 'warning'">
          mdi-alert
        </v-icon>
        <v-toolbar-title>{{ configs.title }}</v-toolbar-title>
        <v-icon
          v-if="configs.closeIcon"
          @click="emit('close')"
        >
          mdi-{{ configs.closeIcon }}
        </v-icon>
      </v-toolbar>
      <v-card-text>
        {{ configs.message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="configs.yesText?.length" variant="elevated" @click="emit('yes')">
          {{ configs.yesText }}
        </v-btn>
        <v-btn v-if="configs.noText?.length" variant="elevated" @click="emit('no')">
          {{ configs.noText }}
        </v-btn>
        <v-btn
          v-if="configs.closeText?.length"
          :color="configs.type === 'warning' ? 'unset' : 'primary'"
          variant="elevated"
          @click="emit('close')"
        >
          {{ configs.closeText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';

interface DialogConfig {
  title: string;
  type: string;
  message: string;
  yesText?: string;
  noText?: string;
  closeText?: string;
  closeIcon?: string;
}
interface Props {
  configs: DialogConfig;
}

const { configs } = defineProps<Props>();

const emit = defineEmits(['close', 'yes', 'no']);

const getColor = computed(() => {
  switch (configs.type) {
    case 'info':
      return 'primary';
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    default:
      return 'primary';
  }
});

const showDialog = ref(true);
</script>
<style scoped>
  .v-toolbar.bg-warning .v-toolbar-title {
    color: #3e3f00;
    font-weight: 700;
  }
  .v-toolbar.bg-warning .v-icon {
    color: #3e3f00;
  }
  .v-toolbar__content > .v-toolbar-title {
    margin-inline-start: 12px;
  }
</style>
